// extracted by mini-css-extract-plugin
export default {"genericSelect":"GenericStyles_genericSelect__Ml7oG","GenericButton":"GenericStyles_GenericButton__kKVjO"};